import { useCallback, useState } from 'react';

import { TTab } from '@/components/global/Tabs/Tab';

import { TRecommendation } from '@/services/requests/Recommendation/types/template6';

import { getValue } from '@/helpers/GetValueHelper';

const useTabs = (data: TRecommendation[]) => {
  const [tabItems, setTabItems] = useState<TTab[]>(() => {
    return data.map((item, index) => ({
      id: item.idLiferay,
      key: item.idLiferay,
      label: item.subtitle,
      viewed: false,
      active: index === 0,
      recommendationId: item.id,
      theme: item.theme.replace(/"|\[|\]/g, ''),
    }));
  });

  const handleTabClick = useCallback((param: string) => {
    setTabItems(prev => {
      return prev.map(item => {
        return {
          ...item,
          active: item.id === param,
        };
      });
    });
  }, []);

  const getTabActive = () => {
    const item = tabItems.find(tabItem => tabItem.active);
    return getValue(item, 'id', '');
  };
  return {
    tabItems,
    // hasOptions,
    // hasTabs,
    getTabActive,
    // getTabName,
    onTabClick: handleTabClick,
  };
};

export default useTabs;
